import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Cookie.svg?component
var Cookie_exports = /* @__PURE__ */ __exportAll({
	default: () => Cookie_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "M15.739 8.061c-2.02.404-4.041-1.01-4.445-3.03-.202-1.01 0-2.223.606-3.031C6.445 2 2 6.445 2 11.9s4.445 9.9 9.9 9.9 9.9-4.445 9.9-9.9v-.808c-1.616 1.212-4.04.808-5.253-.808-.606-.606-.808-1.415-.808-2.223"
	}, null, -1), createElementVNode("path", {
		fill: "currentColor",
		d: "M8.667 15.133a1.212 1.212 0 1 0 0-2.425 1.212 1.212 0 0 0 0 2.425m4.243 1.212a1.212 1.212 0 1 0 0-2.424 1.212 1.212 0 0 0 0 2.424M9.88 9.88a1.212 1.212 0 1 0 0-2.425 1.212 1.212 0 0 0 0 2.425"
	}, null, -1)])]);
}
var Cookie_default = { render: render$1 };
//#endregion
export { Cookie_exports, Cookie_default as default, render$1 as render };

//# sourceMappingURL=Cookie.svg_component.js.map